module.exports = __webpack_public_path__ + "static/media/loading_ball.b58fc217.gif";